
import mainblock from './mainblock.js'
import minies from './minies.js'
import media from './media.js'

const state = {
           
    color:'#fff',
    name:'Spezifikation',
    showminies: true,
    showmedia: false,
    vuexnamespace: 'specifications',
    initmutation:'specifications/SPECIFICATION_INIT_SPECIFICATION',
    backlink:'entities',
    duplicateable:true,
    helptext:"Hiermit wird die Art der Zutat/ des Rezepts näher erläutert. Glatt oder kraus für Peterilie zum Beispiel \n\
            wäre ein solch ergänzendes Attribut.<br><br> Der goldene Haken dient der Speicherung. Mit dem schwarzen Kreuz\n\
            wird ohne zu speichern das Formular verlassen. Mit dem Doppelhaken wird der Datensatz dupliziert."
                                                   
    
};

export default {
    namespaced: true,
    modules: {
        mainblock: mainblock,
        minies:minies,
        media:media        
    },
    state,
  
};